import 'slick-carousel';

export const productChangeVariants = ($this, $form, $product) => {
  const $select = $form.find('.js-select-global')
  let optionString
  const values = []
  let optionSelectedFlag = false

  $form
    .removeClass('form-product--sold-out')

  $form
    .find('.js-product-btn')
    .removeAttr('disabled')

  $form.find('.js-product-options').each(function () {
    const $options = $(this)
    const $linkSelected = $options.find('ul .is-current a')
    const elemVal = $linkSelected.data('value-title')

    values.push(elemVal)
  })

  if (values.indexOf(undefined) === -1) {
    if (values.length === 1) {
      optionString = `[data-option-1="${values[0]}"]`
    } else if (values.length === 2) {
      optionString = `[data-option-1="${values[0]}"][data-option-2="${values[1]}"]`
    } else {
      optionString = `[data-option-1="${values[0]}"][data-option-2="${values[1]}"][data-option-3="${values[2]}"]`
    }

    if ($select.find(`option${optionString}`).length) {
      $select.find(`option${optionString}`).prop('selected', 'selected')
    } else {
      optionSelectedFlag = true
    }

    // New Selected Option
    const $optionSelected = $select.find('option:selected')
    const price = $optionSelected.data('price')

    // Sold Out
    if ($optionSelected.is(':disabled') || optionSelectedFlag) {
      $form
        .addClass('form-product--sold-out')
        .find('.js-product-btn')
        .attr('disabled', 'disabled')
    }

    if ($optionSelected.data('variant-image') !== '' && !optionSelectedFlag) {
      const variantImage = $optionSelected.data('variant-image')
      const $sliderImages = $product.find('.js-slider-product .js-slider-product-slides')
      const $slideImageTarget = $sliderImages.find(`[data-slide-index][data-slide-image-src="${variantImage}"]`)

      if ($slideImageTarget.length) {
        $sliderImages.slick('slickGoTo', parseInt($slideImageTarget.data('slide-index')));
      }
    }

    // Price
    if ($product.find('.js-product-price').length) {
      $product.find('.js-product-price').html(price)
    }
  }
}
